import React, { useState } from 'react';
import { ApMenuTrigger } from '@alixpartners/ui-components';
import { DropdownItem } from '../DropdownItem';
import { StyledMenu } from '../NavFilter.styles';
import { Wrapper, Header } from './GroupSelect.styles';

export const GroupSelect = ({ data, name, selected, onChange, type }) => {
	const [isOpen, setOpen] = useState(false);

	const toggleMenu = open => {
		setOpen(open);
	};

	const handleChange = (name, option) => {
		onChange({
			...selected,
			indirectTaxonomy: option.value,
			directTaxonomy: option.value === 3 ? 1 : option.value,
		});
	};

	return (
		<StyledMenu
			button={
				<div style={{ width: 'fit-content' }}>
					<ApMenuTrigger isOpen={isOpen}>{name}</ApMenuTrigger>
				</div>
			}
			placement="bottom-start"
			toggleMenu={toggleMenu}
			isOpen={isOpen}
		>
			{data.map(
				(group, index) =>
					index === Number(type) && (
						<Wrapper key={index}>
							<Header>{group.label}</Header>
							{group.options.map((item, index) => (
								<DropdownItem
									{...item}
									key={index}
									single
									onChange={() => handleChange(group.name, item)}
									selected={String(selected[group.name]) === String(item.value)}
								/>
							))}
						</Wrapper>
					)
			)}
		</StyledMenu>
	);
};
